{
  "action": {
    "confirm": "Bestätigen",
    "delete": "Löschen",
    "discard": "Verwerfen",
    "keep": "Behalten",
    "restore": "Wiederherstellen",
    "retire": "Zurückziehen"
  },
  "empty": "Hier sind keine Erinnerungen.",
  "inThread": {
    "keptHere": "Die Erinnerung, die dieser Durchlauf behält",
    "title_one": "{{count}} Erinnerung aus diesem Durchlauf behalten",
    "title_other": "{{count}} Erinnerungen aus diesem Durchlauf behalten"
  },
  "keep": {
    "explanation": "Die Erinnerung verlinkt diese Durchlauf-Passagen, damit Agenten den genauen Wortlaut lesen können.",
    "fromEntry": "Durchlauf-Eintrag #{{number}}",
    "note": "Notiz (optional)",
    "noteHelp": "In eigenen Worten, wenn die Passage allein nicht sagt, warum sie wichtig ist.",
    "skipped_one": "{{count}} markierter Teil lässt sich nicht zitieren und bleibt weg: Er ist kein Text einer Nachricht, Antwort oder eines Kommentars.",
    "skipped_other": "{{count}} markierte Teile lassen sich nicht zitieren und bleiben weg: Sie sind kein Text einer Nachricht, Antwort oder eines Kommentars.",
    "title": "Titel"
  },
  "keepAction": "Als Erinnerung behalten",
  "lastUsed": "genutzt {{at}}",
  "mine": {
    "explanation": "Erinnerungen, die nur Sie und Ihre Agenten lesen können. Wählen Sie ein Projekt, um dessen persönliche Erinnerungen zu sehen.",
    "explanationInProject": "Ihre persönlichen Erinnerungen für {{project}}. Nur Sie und Ihre Agenten können sie lesen.",
    "title": "Meine Erinnerungen"
  },
  "neverUsed": "nie genutzt",
  "openThread": "Ihren Durchlauf öffnen",
  "origin": {"agent": "von einem Agenten gespeichert", "person": "von einer Person behalten"},
  "reason": "Warum: {{reason}}",
  "saved": {
    "kept": "Der Agent hat eine Erinnerung behalten: {{title}}.",
    "keptPersonal": "Der Agent hat eine persönliche Erinnerung behalten.",
    "proposed": "Der Agent hat eine Erinnerung vorgeschlagen: {{title}}. Sie wartet auf die Bestätigung einer Person.",
    "proposedPersonal": "Der Agent hat eine persönliche Erinnerung vorgeschlagen. Sie wartet auf Ihre Bestätigung.",
    "review": "Review in ihrem Durchlauf"
  },
  "state": {
    "active": "Aktiv",
    "proposed": "Wartend",
    "retired": "Zurückgezogen",
    "stale": "Ungenutzt"
  },
  "stateFilter": "Zustand der Erinnerung",
  "step": {
    "noMemory": "Dieser Review-Schritt nennt keine Erinnerung.",
    "noPassages": "Dieser Schritt nennt keine Passagen zum Behalten.",
    "waitsForOwner": "Nur die Person, der diese Erinnerung gehört, kann sie bestätigen oder verwerfen."
  },
  "title": "Erinnerungen",
  "uses_one": "{{count}} Nutzung",
  "uses_other": "{{count}} Nutzungen",
  "wording": {
    "discardDraft": "Entwurf verwerfen",
    "edit": "Bearbeiten",
    "notSaved": "Ihr Entwurf wurde nicht gespeichert: Den Wortlaut hat der Review-Schritt übernommen.",
    "save": "Wortlaut speichern"
  }
}
